import {useState} from 'react';

type Props = {
	text: string;
};

export const ButtonCopyToClipboard = (props: Props) => {
	const [buttonLabel, setButtonLabel] = useState<string>('Copy');
	return (
		<>
			<button
				onClick={() => {
					navigator.clipboard.writeText(props.text!);
					if (buttonLabel === 'Copied!') {
						setButtonLabel('Copied again!');
					} else {
						setButtonLabel('Copied!');
					}
				}}
			>
				{buttonLabel}
			</button>
		</>
	);
};
